module.exports = __webpack_public_path__ + "img/stock.bf4ab33a.jpg";